var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMealIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 10.84L8.43 8.00996L2.24 1.82996C1.76 1.34996 0.930002 1.47996 0.630002 2.09996C-0.0799976 3.58996 0.180002 5.41996 1.41 6.65996L5.6 10.84ZM12.38 9.02996C13.91 9.73996 16.06 9.23996 17.65 7.64996C19.56 5.73996 19.93 2.99996 18.46 1.52996C17 0.0699574 14.26 0.429958 12.34 2.33996C10.75 3.92996 10.25 6.07996 10.96 7.60996L1.9 16.67C1.51 17.06 1.51 17.69 1.9 18.08C2.29 18.47 2.92 18.47 3.31 18.08L9.5 11.91L15.68 18.09C16.07 18.48 16.7 18.48 17.09 18.09C17.48 17.7 17.48 17.07 17.09 16.68L10.91 10.5L12.38 9.02996Z",
    fill: "#27BAC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMealIcon);
export default __webpack_public_path__ + "static/media/MealIcon.074b60896a55f0e749b6eaff66c46a79.svg";
export { ForwardRef as ReactComponent };